import { AppBar, styled } from "@mui/material";
import { IStyledAppBarProps } from "./types";
import { drawerWidth as defaultDrawerWidth } from "../../../consts/drawerWidth";

const StyledAppBar = styled(AppBar, {
	shouldForwardProp: (prop) => prop !== 'open' && prop !== 'chatWidth' && prop !== 'isResizing',
})<IStyledAppBarProps>(({ theme, chatWidth, isResizing }) => {
	const width = chatWidth ?? defaultDrawerWidth;
	// Skipped while the chat is being dragged — see MainContent/styled.ts for why.
	const transition = isResizing ? 'none' : theme.transitions.create(['margin', 'width'], {
		easing: theme.transitions.easing.sharp,
		duration: theme.transitions.duration.leavingScreen,
	});

	return {
		height: theme.spacing(8),
		backgroundColor: (theme as any).palette.background.default,
		backgroundImage: "none",
		borderBottom: "1px solid rgba(255, 255, 255, 0.06)",
		boxShadow: "none",
		padding: theme.spacing(2),
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		transition,
		variants: [
			{
				props: { open: true } as Partial<IStyledAppBarProps>,
				style: {
					width: `calc(100% - ${width}px)`,
					marginRight: `${width}px`,
					transition: isResizing ? 'none' : theme.transitions.create(['margin', 'width'], {
						easing: theme.transitions.easing.easeOut,
						duration: theme.transitions.duration.enteringScreen,
					}),
					// no mobile o chat cobre a tela inteira, então o AppBar não encolhe
					[theme.breakpoints.down('md')]: {
						width: '100%',
						marginRight: 0,
					},
				},
			},
		],
		"& .MuiSvgIcon-root": {
			color: theme.palette.primary.dark
		}
	}
});

export { StyledAppBar }
